import I18n from 'lib/i18n'
import './styles.scss'

import React from 'react'

const Heart = ({ withText, isActive, onClick }) => (
  <div className='generic-heart-container' onClick={onClick} style={{ padding: '0px 5px', cursor: 'pointer' }}>
    <svg viewBox='0 0 53 51' focusable='false' className='generic-heart'>
      <path
        className={isActive ? 'active' : ''}
        d='M51.911,16.242C51.152,7.888,45.239,1.827,37.839,1.827c-4.93,0-9.444,2.653-11.984,6.905
    c-2.517-4.307-6.846-6.906-11.697-6.906c-7.399,0-13.313,6.061-14.071,14.415c-0.06,0.369-0.306,2.311,0.442,5.478
    c1.078,4.568,3.568,8.723,7.199,12.013l18.115,16.439l18.426-16.438c3.631-3.291,6.121-7.445,7.199-12.014
    C52.216,18.553,51.97,16.611,51.911,16.242z'
      />
    </svg>
    {withText && (
      <div>
        {isActive ? I18n.t('courses.show.favourites_button_remove') : I18n.t('courses.show.favourites_button_add')}
      </div>
    )}
    <div className='text-pusher'>{I18n.t('courses.show.favourites_button_remove')}</div>
    <div className='text-pusher'>{I18n.t('courses.show.favourites_button_add')}</div>
  </div>
)

export default Heart
